import { makeAutoObservable, runInAction } from 'mobx';
import { GasAndTime } from './eth-gasstation';

export class BidModalModel {

    isLoading: boolean = false;
    errorMessage: string = '';
    successMessage: string = '';
    gas: GasAndTime = {};
    endTime: number = 0;
    priceWhenOpened: string = '';

    constructor() {
        makeAutoObservable(this);
    }

    reset(isLoading = false) {
        runInAction(() => {
            this.isLoading = isLoading;
            this.priceWhenOpened = '';
            this.errorMessage = '';
            this.successMessage = '';
        });
    }

    setGasEstimate(value: GasAndTime) {
        this.gas = value;
    }

    setIsLoading(value: boolean) {
        this.isLoading = value;
    }

    setErrorMessage(value: string) {
        this.errorMessage = value;
    }

    setSuccessMessage(value: string) {
        this.successMessage = value;
    }

    setEndTime(value?: number) {
        if (value) {
            this.endTime = value;
        }
    }

    setPriceWhenOpened(value?: number) {
        if (value) {
            this.priceWhenOpened = value.toString();
        }
    }
}